import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";

const DepartmentSchema = Yup.object().shape({
  Name: Yup.string().required("Department name is required"),
});

const AddEdit_DepartmentMaster = () => {
  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      F_FirmMaster: "",
      F_BranchMaster: "",
      Ordering: "",
      IsSundayInclude: false,
      IsDirectWages: false,
      IsNotInUse: false,
    },
    FirmMaster: [],
    BranchMaster: [],
    isProgress: false,
  });

  const [payrollParams, setPayrollParams] = useState(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_SAVE = "DepartmentMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/DepartmentMaster/Id`;

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FirmMaster", `${API_WEB_URLS.MASTER}/0/token/FirmMaster/Id/0`);

    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  // Restore branches and payroll params when editing an existing record
  useEffect(() => {
    if (state.formData && state.formData.F_FirmMaster) {
      Fn_FillListData(dispatch, setState, "BranchMaster", `${API_WEB_URLS.MASTER}/0/token/BranchMaster/F_FirmMaster/${state.formData.F_FirmMaster}`);
      loadPayrollParams(state.formData.F_FirmMaster);
    }
  }, [state.formData.F_FirmMaster]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadPayrollParams = (firmId) => {
    if (!firmId) { setPayrollParams(null); return; }
    Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/PayrollParameter/TBL.F_FirmMaster/${firmId}`)
      .then(res => setPayrollParams(Array.isArray(res) && res.length > 0 ? res[0] : null))
      .catch(() => setPayrollParams(null));
  };

  const handleFirmChange = (firmId, handleChange, e) => {
    handleChange(e);
    if (firmId) {
      Fn_FillListData(dispatch, setState, "BranchMaster", `${API_WEB_URLS.MASTER}/0/token/BranchMaster/F_FirmMaster/${firmId}`);
      loadPayrollParams(firmId);
    } else {
      setState((prev) => ({ ...prev, BranchMaster: [] }));
      setPayrollParams(null);
    }
  };

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("Name", values.Name);
      formData.append("F_FirmMaster", values.F_FirmMaster);
      formData.append("F_BranchMaster", values.F_BranchMaster);
      formData.append("Ordering", values.Ordering);
      formData.append("IsSundayInclude", values.IsSundayInclude ? true : false);
      formData.append("IsDirectWages", values.IsDirectWages ? true : false);
      formData.append("IsNotInUse", values.IsNotInUse ? true : false);

      Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE,
        true,
        "memberid",
        navigate,
        "/DepartmentMaster"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Department Master" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Department Master</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={state.formData}
                  enableReinitialize
                  validationSchema={DepartmentSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      handleSubmit(values);
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="text-label">Department Name *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Name"
                            value={values.Name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.Name && <div className="text-danger fs-12">{errors.Name}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Firm</label>
                          <select
                            className="form-control"
                            name="F_FirmMaster"
                            value={values.F_FirmMaster}
                            onBlur={handleBlur}
                            onChange={(e) => handleFirmChange(e.target.value, handleChange, e)}
                          >
                            <option value="">-- Select Firm --</option>
                            {state.FirmMaster.map((f) => <option key={f.Id} value={f.Id}>{f.Name}</option>)}
                          </select>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Branch</label>
                          <select
                            className="form-control"
                            name="F_BranchMaster"
                            value={values.F_BranchMaster}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Branch --</option>
                            {state.BranchMaster.map((b) => <option key={b.Id} value={b.Id}>{b.Name}</option>)}
                          </select>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Ordering</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Ordering"
                            value={values.Ordering}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        {payrollParams?.IsDepartmentWisePayroll && (
                          <div className="col-md-6 mb-3 d-flex align-items-center mt-2">
                            <div className="form-check me-4">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="IsSundayInclude"
                                name="IsSundayInclude"
                                checked={!!values.IsSundayInclude}
                                onChange={(e) => setFieldValue("IsSundayInclude", e.target.checked)}
                              />
                              <label className="form-check-label" htmlFor="IsSundayInclude">
                                Sunday Include
                              </label>
                            </div>
                            <div className="form-check me-4">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="IsDirectWages"
                                name="IsDirectWages"
                                checked={!!values.IsDirectWages}
                                onChange={(e) => setFieldValue("IsDirectWages", e.target.checked)}
                              />
                              <label className="form-check-label" htmlFor="IsDirectWages">
                                Direct Wages
                              </label>
                            </div>
                          </div>
                        )}

                        <div className="col-md-6 mb-3 d-flex align-items-center mt-4">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsNotInUse"
                              name="IsNotInUse"
                              checked={!!values.IsNotInUse}
                              onChange={(e) => setFieldValue("IsNotInUse", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="IsNotInUse">
                              Not In Use
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="mt-3">
                        <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger light"
                          onClick={() => navigate("/DepartmentMaster")}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEdit_DepartmentMaster;
